Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterApiContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.TwitterApiContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    data = socialContent.data or socialContent
    return data.type == 'twitter' and socialContent.group_type == 'twitterapi'
